import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'lodash-es';

const Recommendation = ({ strings }) => (
  <>
    <div className="style-recommendation-layout">
      <span className="text-weight"> {get(strings, 'recommendation')} </span>
    </div>
    <div className="style-recommendation-triangle-layout" />
  </>
);

Recommendation.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  strings: PropTypes.object,
};

Recommendation.defaultProps = {
  strings: {},
};

export default Recommendation;
